import { ChannelkartNetworkGet, ChannelkartNetworkPut } from "./networkService";

export async function getEntityApprovals(startDate: string, endDate: string) {
    const response = await ChannelkartNetworkGet(`/v1/entityApprovals?filter=status%3Apending and lastModifiedTime[gte]:${startDate} and lastModifiedTime[lte]:${endDate}&size=8000&page=0`);
    return response;
}

export async function getAllOrderDetailsData(id: any){
    const response = await ChannelkartNetworkGet(`/v1/query/getOrderDetailsById?id=${id}`);
    return response;
}

export async function updateOrderStatus(requestBody: any, id: any){
    const response = await ChannelkartNetworkPut(`/orders/status/${id}`, requestBody);
    return response;
}

export async function getUserDetailsById(id: string) {
    const response = await ChannelkartNetworkGet(`/v1/entityApprovals?filter=id%3A${id}&size=8000&page=0`);
    return response;
}